/* @flow */

import { createSelector } from '@reduxjs/toolkit';
import {
  hydrateLocations,
  isOnsiteLocation,
  isVirtualLocation,
  isHybridLocations,
} from '@braindate/domain/lib/location/util';
import { getUserLocations } from '@braindate/domain/lib/user/util';

import type { Location } from '@braindate/domain/lib/location/type';
import type { State } from 'src/shared/core/type/reduxTypes';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';
import type { User } from '@braindate/domain/lib/user/type';

/*
 |------------------------------------------------------------------------------
 | Slice selectors
 |------------------------------------------------------------------------------
 */

const getAppLocations = (state) => state.app.location;
const getEntities = (state) => state.domain.entities;

/*
 |------------------------------------------------------------------------------
 | Exports
 |------------------------------------------------------------------------------
 */

export const getAllLocations: (State) => Array<Location> = createSelector(
  [getAppLocations, getEntities],
  (locationsIds, entities) => hydrateLocations(locationsIds, entities),
);

export const getIsMultiLocationEvent: (State) => Array<Location> =
  createSelector(getAllLocations, (locations) => locations.length > 1);

export const getSelfLocations: (state: State) => Array<Location> =
  createSelector(getSelf, (user: User) => (user ? getUserLocations(user) : []));

export const getSelfIsOnsite: (state: State) => boolean = createSelector(
  getSelfLocations,
  (locations) => locations.length > 0 && locations.every(isOnsiteLocation),
);

export const getSelfIsVirtual: (state: State) => boolean = createSelector(
  getSelfLocations,
  (locations) => locations.length > 0 && locations.every(isVirtualLocation),
);

export const getSelfIsHybrid: (state: State) => boolean = createSelector(
  getSelfLocations,
  (locations) => isHybridLocations(locations),
);
